import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  buttonWrapper: {
    width: '100%',
  },
}))

export default useStyles
